module.exports = __webpack_public_path__ + "static/howjsay-home-d86e2c09ba4640fc43bea0b53656eb0e.png";